var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"overlay",style:({opacity: _vm.props.opacity, backgroundColor: _vm.props.color})})}
var staticRenderFns = []

export { render, staticRenderFns }